var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormGrid as FormilyGird } from '@formily/antd';
import { TreeNode, createBehavior, createResource } from '@designable/core';
import { useTreeNode, useNodeIdProps, DroppableWidget, } from '@designable/react';
import { observer } from '@formily/reactive-react';
import { LoadTemplate } from '../../common/LoadTemplate';
import { createFieldSchema } from '../Field';
import { AllSchemas } from '../../schemas';
import { AllLocales } from '../../locales';
import './styles.less';
export var FormGrid = observer(function (props) {
    var node = useTreeNode();
    var nodeId = useNodeIdProps();
    if (node.children.length === 0)
        return React.createElement(DroppableWidget, __assign({}, props));
    var totalColumns = node.children.reduce(function (buf, child) { var _a, _b, _c; return buf + ((_c = (_b = (_a = child.props) === null || _a === void 0 ? void 0 : _a['x-component-props']) === null || _b === void 0 ? void 0 : _b.gridSpan) !== null && _c !== void 0 ? _c : 1); }, 0);
    return (React.createElement("div", __assign({}, nodeId, { className: "dn-grid" }),
        React.createElement(FormilyGird, __assign({}, props, { key: totalColumns }), props.children),
        React.createElement(LoadTemplate, { actions: [
                {
                    title: node.getMessage('addGridColumn'),
                    icon: 'AddColumn',
                    onClick: function () {
                        var column = new TreeNode({
                            componentName: 'Field',
                            props: {
                                type: 'void',
                                'x-component': 'FormGrid.GridColumn',
                            },
                        });
                        node.append(column);
                    },
                },
            ] })));
});
FormGrid.GridColumn = observer(function (props) {
    return (React.createElement(DroppableWidget, __assign({}, props, { "data-span": props.gridSpan, style: __assign(__assign({}, props['style']), { gridColumnStart: "span " + (props.gridSpan || 1) }) }), props.children));
});
FormGrid.Behavior = createBehavior({
    name: 'FormGrid',
    extends: ['Field'],
    selector: function (node) { return node.props['x-component'] === 'FormGrid'; },
    designerProps: {
        droppable: true,
        allowDrop: function (node) { return node.props['x-component'] !== 'FormGrid'; },
        propsSchema: createFieldSchema(AllSchemas.FormGrid),
    },
    designerLocales: AllLocales.FormGrid,
}, {
    name: 'FormGrid.GridColumn',
    extends: ['Field'],
    selector: function (node) { return node.props['x-component'] === 'FormGrid.GridColumn'; },
    designerProps: {
        droppable: true,
        allowDrop: function (node) { return node.props['x-component'] === 'FormGrid'; },
        propsSchema: createFieldSchema(AllSchemas.FormGrid.GridColumn),
    },
    designerLocales: AllLocales.FormGridColumn,
});
FormGrid.Resource = createResource({
    icon: 'GridSource',
    elements: [
        {
            componentName: 'Field',
            props: {
                type: 'void',
                'x-component': 'FormGrid',
            },
            children: [
                {
                    componentName: 'Field',
                    props: {
                        type: 'void',
                        'x-component': 'FormGrid.GridColumn',
                    },
                },
                {
                    componentName: 'Field',
                    props: {
                        type: 'void',
                        'x-component': 'FormGrid.GridColumn',
                    },
                },
                {
                    componentName: 'Field',
                    props: {
                        type: 'void',
                        'x-component': 'FormGrid.GridColumn',
                    },
                },
            ],
        },
    ],
});
